
import { defineComponent, watch, ref } from "vue";
import displayManagement from "@/composables/displayManagement";
import EditDisplayDialog from "@/components/Controller/EditDisplayDialog.vue";
import DisplayItem from "@/components/Controller/DisplayItem.vue";
import { useStore } from "vuex";

export default defineComponent({
  props: {
    account_id: String,
  },
  components: { EditDisplayDialog, DisplayItem },
  /* if (account.value) {
        await loadDisplays(account.value.id);
      } else {
        alert("Tried to load displays but had no account");
      } */

  setup(props) {
    const store = useStore();
    const edit_display_id = ref<String | null>(null);
    
    const { displays, displays_loaded, loadDisplays, createDisplay } =
      displayManagement();

    watch(
      () => props.account_id,
      async (account_id) => {
        if (account_id) {
          await loadDisplays(account_id);
        } else {
          alert("Tried to load displays but had no account");
        }
      }
    );

    const editDisplay = (display_id: string) => {
      edit_display_id.value = display_id;
    };

    

    return {
      createDisplay,
      displays,
      displays_loaded,
      editDisplay,
      edit_display_id,
      store
    };
  },
});
